module.exports = __webpack_public_path__ + "img/mn.ab522741.svg";